import { render, staticRenderFns } from "./DraftFoundDialog.vue?vue&type=template&id=0d6b9fd3&scoped=true&"
import script from "./DraftFoundDialog.vue?vue&type=script&lang=js&"
export * from "./DraftFoundDialog.vue?vue&type=script&lang=js&"
import style0 from "./DraftFoundDialog.vue?vue&type=style&index=0&id=0d6b9fd3&prod&scoped=true&lang=css&"
import style1 from "./DraftFoundDialog.vue?vue&type=style&index=1&id=0d6b9fd3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b9fd3",
  null
  
)

export default component.exports